import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'
import { type EarnPointsCalculationOptions, mapRequestToPayload, mapResponseToCalculation } from 'api/mappers/loyalty/mapLoyaltyEarnPointsCalculation'
import buildPointsKey from 'loyalty/lib/pointsCalculation/buildPointsKey'

type BatchPayload = paths['/api/lux-loyalty/points/calculate-earn/batch']['post']['requestBody']['content']['application/json']
type BatchResponse = paths['/api/lux-loyalty/points/calculate-earn/batch']['post']['responses']['200']['content']['application/json']

const BATCH_LIMIT = 100

export async function requestLoyaltyEarnPointsCalculationBatch(
  requests: Array<App.LoyaltyPointsEarnCalculationRequest>,
  options: EarnPointsCalculationOptions,
): Promise<Array<App.LoyaltyPointsEarnCalculation | undefined>> {
  const chunks: Array<Array<App.LoyaltyPointsEarnCalculationRequest>> = []
  for (let i = 0; i < requests.length; i += BATCH_LIMIT) {
    chunks.push(requests.slice(i, i + BATCH_LIMIT))
  }

  const chunkResponses = await Promise.all(
    chunks.map(chunk => {
      const payload: BatchPayload = {
        items: chunk.map(request => ({
          ...mapRequestToPayload(request, options),
          itemIdentifier: buildPointsKey(request, options.customerId),
        })),
      }
      return requestUtils.post<BatchResponse, BatchPayload>('/api/lux-loyalty/points/calculate-earn/batch',
        payload,
        { credentials: 'include' },
      )
    }),
  )

  return requests.map((request, index) => {
    const chunkIndex = Math.floor(index / BATCH_LIMIT)
    const indexInChunk = index % BATCH_LIMIT
    const batchResult = chunkResponses[chunkIndex].results[indexInChunk]
    // batchResult being undefined should be never happen, unless the server is misbehaving
    // so this is more like additional check
    if (!batchResult || batchResult.status === 'error') {
      return undefined
    }

    return mapResponseToCalculation(request, batchResult.result)
  })
}
